/* eslint class-methods-use-this: 0 */
import React, { Component } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import CargomaticModal from 'components/v2/modal';
import 'react-datepicker/dist/react-datepicker.css';
function ArrivalFormFooter({ disabled, onSave, onCancel }) {
    return (React.createElement("div", { className: "flex items-center space-x-2" },
        React.createElement("button", { className: "button button-green", disabled: disabled, onClick: onSave }, "Save"),
        React.createElement("button", { className: "button button-secondary", onClick: onCancel }, "Cancel")));
}
const CustomInput = (props) => {
    return (React.createElement("input", { className: "form-field", type: "text", onClick: props.onClick, placeholder: "Date", value: props.value }));
};
export default class ArrivedModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            meta: {},
        };
    }
    handleDateChange(value) {
        this.setState((prevState) => ({
            meta: Object.assign(Object.assign({}, prevState.meta), { date: value }),
        }));
    }
    onComplete() {
        const meta = this.state.meta;
        meta.date = moment(meta.date).toISOString();
        this.setState({ meta: {} }, () => {
            this.props.onComplete('arrived', meta);
            this.props.onHide();
        });
    }
    hide() {
        this.setState({ meta: {} }, () => {
            this.props.onHide();
        });
    }
    render() {
        return (React.createElement(CargomaticModal, { show: this.props.show, onHide: () => this.hide(), title: "Arrival Information", footer: React.createElement(ArrivalFormFooter, { disabled: this.props.disabled, onSave: () => this.onComplete(), onCance: () => this.hide() }) },
            React.createElement("label", { className: "form-label mb-1", htmlFor: "arrival-date" }),
            React.createElement(DatePicker, { id: "arrival-date", fixedHeight: true, customInput: React.createElement(CustomInput, { value: this.state.meta.date }), placeholderText: "Arrival Date", selected: this.state.meta.date, onChange: this.handleDateChange, showTimeSelect: true, timeFormat: "hh:mma", timeIntervals: 5, dateFormat: "L LT", isClearable: true })));
    }
}
